import { GraduationCap, ExternalLink, ArrowRight, Star } from "lucide-react";
import { wagiUrl, WAGI_PATHS, WAGI_ENROLL_LINE, getFeaturedCourse } from "@/lib/wagi";

const CHIPS = ["2-Year Certificate of Ministry", "9 Courses", "Founded 2019 by Apostle Dayna Milam"];

const TILES = [
  { id: "year1", title: "Year 1 | Freedom", note: "$750", path: WAGI_PATHS.year1 },
  { id: "year2", title: "Year 2 | Discipleship", note: "$750", path: WAGI_PATHS.year2 },
  { id: "short", title: "Short Courses", note: "From $50", path: WAGI_PATHS.shortCourses },
];

export default function WagiHomeSection() {
  const featured = getFeaturedCourse();
  return (
    <section data-testid="wagi-home-section" className="py-20 md:py-28 bg-navy text-white relative overflow-hidden border-t border-gold/20">
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-gold/5 rounded-full blur-3xl pointer-events-none" />
      <div className="container-page relative z-10 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <GraduationCap className="h-5 w-5 text-gold" />
            <span className="text-gold text-sm font-heading uppercase tracking-widest font-bold">Word Alive Global Institute</span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl leading-tight mb-4">Training Leaders for Kingdom Purpose</h2>
          <p className="text-white/70 text-base leading-relaxed max-w-xl mb-2">
            College-level ministry training, accredited by ACEA.
          </p>
          <p className="text-gold text-sm font-semibold mb-6" data-testid="wagi-enroll-line">{WAGI_ENROLL_LINE}</p>
          <div className="flex flex-wrap gap-2 mb-8">
            {CHIPS.map((c) => (
              <span key={c} className="text-xs border border-gold/40 text-white/80 rounded-full px-3 py-1">{c}</span>
            ))}
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href={wagiUrl("home")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wagi-home-cta"
              className="inline-flex items-center gap-2 bg-gold text-navy font-bold uppercase tracking-wider text-xs h-12 px-7 rounded-full hover:bg-gold/90 transition-colors"
            >
              Explore the Institute <ExternalLink className="h-4 w-4" />
            </a>
            <a
              href={wagiUrl("home", WAGI_PATHS.courses)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="wagi-home-courses-link"
              className="inline-flex items-center gap-2 border border-white/30 text-white font-bold uppercase tracking-wider text-xs h-12 px-7 rounded-full hover:border-gold hover:text-gold transition-colors"
            >
              View Courses
            </a>
          </div>
        </div>

        <div className="grid gap-4">
          <a
            href={wagiUrl("home-featured", featured.path)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="wagi-featured-course"
            className="group flex items-center justify-between rounded-sm border-2 border-gold bg-gold/10 hover:bg-gold/20 transition-colors p-5"
          >
            <div className="min-w-0">
              <p className="flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-bold text-gold mb-1">
                <Star className="h-3.5 w-3.5 fill-gold" /> Course of the Week
              </p>
              <p className="font-heading text-2xl" data-testid="wagi-featured-course-title">{featured.title}</p>
              <p className="text-gold text-sm font-semibold mt-1">{featured.price} · Self-paced online</p>
            </div>
            <ArrowRight className="h-5 w-5 text-gold shrink-0 ml-3 group-hover:translate-x-1 transition-transform" />
          </a>
          {TILES.map((t) => (
            <a
              key={t.id}
              href={wagiUrl("home", t.path)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`wagi-tile-${t.id}`}
              className="group flex items-center justify-between rounded-sm border border-white/10 bg-white/5 hover:border-gold/60 hover:bg-white/10 transition-colors p-5"
            >
              <div>
                <p className="font-heading text-xl">{t.title}</p>
                <p className="text-gold text-sm font-semibold mt-1">{t.note}</p>
              </div>
              <ArrowRight className="h-5 w-5 text-gold group-hover:translate-x-1 transition-transform" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
